var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FilterCheckBoxGroup',{attrs:{"labels":_vm.labels,"initial-value":['Fraud Block'],"is-pair-column":""},on:{"onChange":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }